var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.styles.card, _vm.styles.card_small]},[_c('span',{class:_vm.styles.label},[_vm._v(_vm._s(_vm.label))]),(_vm.loading)?_c('Loading',{staticClass:"small"}):_c('div',{class:[_vm.styles.stat, { 'color-gray-600': !_vm.value || _vm.value === 0 }]},[_vm._v(_vm._s(_vm._f("PercentageFilter")(_vm.value)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }